import React from 'react';
import { Flex, Text } from '@/components/ui';

interface ImportProcessingTimelineProps {
  createdAt: string;
  processingStartedAt?: string;
  completedAt?: string;
  failedAt?: string;
}

export const ImportProcessingTimeline: React.FC<ImportProcessingTimelineProps> = ({
  createdAt,
  processingStartedAt,
  completedAt,
  failedAt,
}) => {
  if (!processingStartedAt && !completedAt && !failedAt) {
    return null;
  }

  return (
    <Flex direction="column" gap="1">
      <Text size="2" weight="medium">
        Timeline
      </Text>
      <Flex direction="column" gap="1" style={{ fontSize: '13px' }}>
        <Text size="3xsmall">
          Created: {new Date(createdAt).toLocaleString()}
        </Text>
        {processingStartedAt && (
          <Text size="3xsmall">
            Processing started: {new Date(processingStartedAt).toLocaleString()}
          </Text>
        )}
        {completedAt && (
          <Text size="3xsmall" color="success">
            Completed: {new Date(completedAt).toLocaleString()}
          </Text>
        )}
        {failedAt && (
          <Text size="3xsmall" color="error">
            Failed: {new Date(failedAt).toLocaleString()}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
